import { CallStatus } from '../../enums';
import { setCallStatus } from '../../util/error-handling/StatusByCallHelpers';

import { CloseoutCall, CloseoutState } from './types';


export function setCloseoutCallStatus(
  call: CloseoutCall,
  status: CallStatus,
  state: CloseoutState,
  errorCode?: number,
) {
  setCallStatus(call, CloseoutCall[call], status, state.statusByCall, errorCode, state.errorsLog);
}
